import { Controller } from '@hotwired/stimulus'

let processEmbeds = false

export default class extends Controller {
    static targets = ['placeholder', 'embed', 'button']
    static values = {
        cookieId: Number,
        permalink: String,
    }

    #domLoadedEventListener = null

    connect() {
        // We need to wait for DOM ready so that we have the cookiebar instance
        if ('loading' === document.readyState) {
            document.addEventListener('DOMContentLoaded', this.#domLoadedEventListener = () => {
                this.#addInstagramJs()
            })
        } else {
            this.#addInstagramJs()
        }
    }

    accept() {
        // We need to wait for DOM ready so that we have the cookiebar instance
        if ('loading' === document.readyState) {
            document.addEventListener('DOMContentLoaded', this.#domLoadedEventListener = () => {
                this.#doAccept()
            })
        } else {
            this.#doAccept()
        }
    }

    disconnect() {
        if (this.#domLoadedEventListener) {
            document.removeEventListener('DOMContentLoaded', this.#domLoadedEventListener)
        }
    }

    loaded(event) {
        // If the loaded frame belongs to this element, remove the placeholder
        if (this.element.querySelector('#'+event.detail.frameId)) {
            this.placeholderTarget.remove()
        }
    }

    #addInstagramJs() {
        // Do not add instagram JS if consent has not been given or it was already loaded
        if (!this.cookieIdValue || !cookiebar.issetCookie(this.cookieIdValue)) {
            return
        }

        // Set button to disabled now
        if (this.hasButtonTarget) {
            this.buttonTarget.setAttribute('disabled', '')
        }

        // If instagram was already loaded, process embeds again
        this.#processEmbeds()

        if (document.getElementById('instagram-embed')) {
            return
        }

        const script = document.createElement('script')
        script.async = true
        script.src = 'https://www.instagram.com/embed.js'
        script.id = 'instagram-embed'
        document.body.appendChild(script)
    }

    #doAccept() {
        // Check if consent has not been given yet
        if (!cookiebar.issetCookie(this.cookieIdValue)) {
            // Store that consent has been given now within the cookiebar instance
            cookiebar.get().settings.cookies['_'+this.cookieIdValue].confirmed = true

            // Update the cookiebar storage manually to store the consent
            const storage = cookiebar.getStorage()
            storage.cookies.push(parseInt(this.cookieIdValue))
            localStorage.setItem(cookiebar.get().settings.token+'_'+cookiebar.get().settings.configId, JSON.stringify(storage))
        }

        // Now show the instagram embed
        this.#addInstagramJs()
    }

    #processEmbeds() {
        if (!window.instgrm) {
            return
        }

        processEmbeds = true

        queueMicrotask(() => {
            if (processEmbeds) {
                processEmbeds = false
                window.instgrm.Embeds.process()
            }
        })
    }
}
